import { useAtomCallback } from 'jotai/utils';
import { useCallback } from 'react';

import { videoSDKAdapterAtom } from '../core/atoms';
import { DataChannelMessage } from '../core/message/types';

export function useSendMessage() {
  const getAdapter = useAtomCallback(useCallback((get) => get(videoSDKAdapterAtom), []));

  return useCallback(
    async (message: DataChannelMessage): Promise<boolean> => {
      const result = await getAdapter().sendMessage(message);

      return result;
    },
    [getAdapter],
  );
}
